<template>
    <div class="w-full mb-3">
        <div class="indicator_item">
            <span class="under_line"></span>
            <div v-for="(item, index) in filteredFlowItem" :key="index" :style="{ width: `${100 / flowItem.length}%` }"
                :class="isClass(index)">
                <!-- <abbr></abbr> -->

                <span class="inline-flex pt-2 name-label text-xs sm:text-xs md:text-sm items-center capitalize">
                    {{ item.name }}
                 <img :src="icon(index)" class="ml-1" />
                </span>
                <i></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["index"],
    data() {
        return {
            isInterState: true,
            filteredFlowItem: [],
            flowItem: [
                {
                    index: 1,
                    name: "Select Route",
                },
                {
                    index: 3,
                    name: "Add Shipments",
                },
                {
                    index: 4,
                    name: "Select Fleet",
                },
                {
                    index: 5,
                    name: "Confirmation",
                },
            ],
        };
    },
    computed: {
        routeLevel() {
            return Number(this.$store.getters?.getNewConsolidationLevel) - 1;
        },
        shipping() {
            return this.$store.getters.getBookingStates
        }
    },
    activated() {
        this.filteredFlowItem = this.flowItem
    },
    mounted() {
        this.filteredFlowItem = this.flowItem
    },
    watch: {
        // "$store.getters.getBookingStates"(val){
        //   const shippingMethod = `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`;
        //   const checktype = (val.reciever === val.sender) && (shippingMethod !== "terminal-to-terminal")
        //   this.filteredFlowItem = this.flowItem
        //   checktype ? this.filteredFlowItem = this.flowItem.filter((item)=> item.name !== "Services") : this.filteredFlowItem = this.flowItem
        // }
    },
    methods: {
        icon(val) {
            if (Number(this.routeLevel) > val) {
                return require("../icons/progressCheck.svg")
            } else if (Number(this.routeLevel) == val) {
                return ""
            } else if (Number(this.routeLevel) < val) {
                return ""
            }
        },
        isClass(val) {
            let classes;
            if (Number(this.routeLevel) > val) {
                classes = "pass-flow-item ";
            } else if (Number(this.routeLevel) == val) {
                classes = "active-flow-item";
            } else if (Number(this.routeLevel) < val) {
                classes = "flow-item";
            }

            return classes;
        },
    },
};
</script>

<style lang="scss" scoped>
.under_line{
    @apply absolute inline-block w-[calc(100%-32px)] h-[4px] left-2 bg-primary-lighterblue top-[calc(100%-12px)]
}
.indicator_item {
    @apply py-3  flex justify-center rounded-xl px-2 mb-3 pb-2 relative;
}

.name-label {
    position: relative;
    left: 0;
    width: 100%;
    display: inline-flex;
    justify-content: center;
    padding-bottom: 5px;
}

.flow-item {
    position: relative;

    i {
        position: relative;
        display: block;
        width: 95%;
        height: 4px;
        border-radius: 50px;
    }
    span{
        @apply text-gray-400
    }
}

.active-flow-item {
    position: relative;

    i {
        position: relative;
        display: block;
        width: 95%;
        height: 4px;
        border-radius: 50px;
        @apply bg-primary-yellow;
        transition: 300ms;
    }
}

.pass-flow-item {
    position: relative;

    i {
        position: relative;
        display: block;
        width: 95%;
        height: 4px;
        border-radius: 50px;
        @apply bg-transparent;
        transition: 300ms;
    }
}

.flow-item:nth-last-child(1),
.active-flow-item:nth-last-child(1),
.pass-flow-item:nth-last-child(1) {
    width: 10px;
}

.min_item {
    min-width: 500px;
}
</style>
